import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/45/thumb-landscape.jpg"

import Slider from "react-slick";

const Post45 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">LOUIS VUITTON／スピーディ25／25 x19 x14cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>LOUIS VUITTON（ルイ・ヴィトン）の定番バッグのひとつ、SPEEDY（スピーディ）。バッグの名前は知らなくとも、一度は目にしたことのあるバッグではないでしょうか？今回は、SPEEDY（スピーディ）のサイズ比較、バッグの種類などを詳しくご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.SPEEDY（スピーディ）について</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.サイズ展開<br></br>■MINI SPEEDY（ミニスピーディ）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2-1" smooth={true} duration={500} offset={-80}>■SPEEDY25（スピーディ25）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2-2" smooth={true} duration={500} offset={-80}>■SPEEDY30（スピーディ30）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.SPEEDY（スピーディ）の付属品</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.SPEEDYBANDOULIÈRE（スピーディ･バンドリエール）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.まとめ</ScrollLink>  
        </p>
      </div>               
      <div name="sec1" className="text-two-cloumn">
        <h2>1.SPEEDY（スピーディ）について</h2>
        <p>SPEEDY（スピーディ）の前身バッグは、1930年にキーポルより小さめの旅行用ハンドバックとして誕生したバッグ、EXPRESS（エクスプレス）。当時の旅人のために作られたバッグなんです。<br></br>その後、移動手段の近代化とスピード感が増していく時代を反映して SPEEDY（スピーディ）の名前に変わりました。<br></br>発売当初のスピーディは、ヌメ革のみを使用していたそうです。使い込むほど味が出るヌメ革ももちろんステキですが、日常使いとなると難しそうです。<br></br>1960年前後にLOUIS VUITTON（ルイ・ヴィトン）の主力となる、モノグラムキャンバスが発売され、現在の仕様となりました。<br></br>コロンとしたシルエット、ボストン型で収納力抜群のバッグは約半世紀たった現在でも変わらず人気のバッグです。<br></br>名前のあとの数字は横幅を表していて、25cmから5cm刻みでサイズ展開があります。<br></br>2011年にはスピーディバンドリエールが発売。ショルダーストラップ付きで2wayでの使用が可能となり、ますます人気となっています。モノグラムシリーズのみならず、色々なラインも販売されています。
        </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/45/1.webp" alt="定番人気！LOUIS VUITTON（ルイ・ヴィトン）SPEEDY（スピーディ）"/>
      </figure>
      <span className="text-center">写真はスピーディ25</span>
      <div name="sec2" className="text-max-width">
        <h2>2.SPEEDY（スピーディ）のサイズ展開</h2>      
      </div>
      <h2>■MINI SPEEDY（ミニスピーディ） /16x10x7cm(幅x高さxマチ)</h2>            
      <figure>
        <StaticImage src="../../images/posts/45/2.jpg"/>
      </figure>
      <p className="text-max-width">
        いちばん小さいスピーディ。長い歴史のあるバッグですので、こちらは1978年の発売で現在は残念ながら廃盤となっています。（ミニにはカデナ、鍵はついていません）
      </p>
      <div name="sec2-1" className="text-max-width">
        <h2>■SPEEDY25（スピーディ25） /25x19x14cm(幅x高さxマチ)</h2>
      </div>
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/45/3.webp"/>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/45/4.webp"/>
        </figure>
      </div>
      <p className="max-width">スピーディ25は1965年、オードリー・ヘップバーンがスピーディ のさらに小さいバッグを作って欲しいとオーダーして生まれました。長く時を経ても愛されるバッグですね。ボストン型なので、コンパクトでありながら収納力は抜群です。
      </p>
      <span className="text-center">モノグラム以外のシリーズはこちら</span>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/45/5.jpg"/>
        <StaticImage src="../../images/posts/45/6.jpg"/>
        <StaticImage src="../../images/posts/45/7.jpg"/>
        <StaticImage src="../../images/posts/45/8.jpg"/>
        <StaticImage src="../../images/posts/45/9.jpg"/>
      </Slider>
      <div name="sec2-2" className="text-max-width">
        <h2>■SPEEDY30（スピーディ30） /30x22x17cm(幅x高さxマチ)</h2>
      </div>           
      <figure>
        <StaticImage src="../../images/posts/45/10.jpg"/>
      </figure>
      <p className="text-max-width">スピーディ25より5cm大きいスピーディ30。スピーディと言えば、思い浮かべる方がいちばん多い定番サイズではないでしょうか？
      </p>
      <span className="text-center">モノグラム以外のスピーディ30はこちら</span>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/45/11.jpg"/>
        <StaticImage src="../../images/posts/45/12.jpg"/>
        <StaticImage src="../../images/posts/45/13.jpg"/>
        <StaticImage src="../../images/posts/45/14.jpg"/>
        <StaticImage src="../../images/posts/45/15.jpg"/>
        <StaticImage src="../../images/posts/45/16.jpg"/>
        <StaticImage src="../../images/posts/45/17.jpg"/>
        <StaticImage src="../../images/posts/45/18.jpg"/>
        <StaticImage src="../../images/posts/45/19.jpg"/>
        <StaticImage src="../../images/posts/45/20.jpg"/>
      </Slider>                                
      <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
       LOUIS VUITTONのバッグを見る
      </Link>         
      <div name="sec3" className="text-max-width">
        <h2>3.SPEEDY（スピーディ）の付属品</h2>
        <p>スピーディには、鍵とカデナが付属でついています。</p> 
      </div>
      <figure>
        <StaticImage src="../../images/posts/45/21.jpg"/>
      </figure>  
      <figure>
        <StaticImage src="../../images/posts/45/22.jpg"/>
      </figure>
      <p className="text-max-width">このようにバッグをロックすることが可能なので、旅行バッグとしても良いですよね。また、折り畳んで収納可能。旅先でも重宝しそうです♡
      </p>       
      <figure>
        <StaticImage src="../../images/posts/45/23.jpg"/>
      </figure>
      <p className="text-max-width">軽くて使いやすいスピーディですが中に入れる荷物によっては底板がないため、バッグが変形しがち。バッグインバッグを入れて使用すると、型崩れすることなく使いやすいのでおすすめです♡<br></br><br></br>サイズ比較をするとこんな感じです。
      </p>
      <figure>
        <StaticImage src="../../images/posts/45/24.jpg"/>
      </figure>
      <span className="text-center">左から SPEEDY30、SPEEDY25、NANO SPEEDY</span>               
      <p className="text-max-width">
        この他に、SPEEDY35（スピーディ35）SPEEDY40（スピーディ40）のサイズ展開があります。<br></br>※NANO SPEEDYのみ、スピーディ･バンドリエールです。<br></br>また、サイズがわからない場合はスピーディのみサイドのレザータブの裏にサイズ表記が記載してあります。
      </p>
      <div name="sec4" className="text-max-width">
        <h2>4.SPEEDYBANDOULIÈRE（スピーディ･バンドリエール）</h2>
        <p>2011年に登場した、定番スピーディに付属でショルダーストラップがついたタイプ。サイズ展開は、スピーディと同じサイズ展開+一番小さいNANO SPEEDY（ナノスピーディ）があります。</p>      
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/45/25.jpg"/>
      </figure>
      <p className="text-max-width">
      付属のショルダーストラップを付けるサイドのヌメ革レザーがアクセントになってます。その他のスピーディ･バンドリエールは、アンプラントレザー、ダミエも人気です。（型は同型なので、いくつか種類を紹介しています）
      </p>
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/45/26.jpg"/>
        <StaticImage src="../../images/posts/45/27.jpg"/>
        <StaticImage src="../../images/posts/45/28.jpg"/>
        <StaticImage src="../../images/posts/45/29.jpg"/>
        <StaticImage src="../../images/posts/45/30.jpg"/>
        <StaticImage src="../../images/posts/45/31.jpg"/>
        <StaticImage src="../../images/posts/45/32.jpg"/>
        <StaticImage src="../../images/posts/45/33.jpg"/>
        <StaticImage src="../../images/posts/45/34.jpg"/>
        <StaticImage src="../../images/posts/45/35.jpg"/>
        <StaticImage src="../../images/posts/45/36.jpg"/>
      </Slider>                                                                 
      <div name="sec5" className="text-two-cloumn">
        <h2>5.まとめ</h2>
        <p>いかがでしたか？LOUIS VUITTON（ルイ・ヴィトン）の長い歴史の中でもSPEEDY（スピーディ）は長く人気のバッグですので、バリエーションがとても豊富です。現在は入手困難となっている人気の限定バッグもラクサスにはあります。ぜひ一度手に取ってみてはいかがでしょうか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/louis_vuitton" className="view-all-button">
       LOUIS VUITTONのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post45

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 45}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
